'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _documentUi = require('./document-ui');

var _documentUi2 = _interopRequireDefault(_documentUi);

var _colorPickerUi = require('./color-picker-ui');

var _colorPickerUi2 = _interopRequireDefault(_colorPickerUi);

var _documentHeader = require('./document-header');

var _documentHeader2 = _interopRequireDefault(_documentHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
  _inherits(WhiteLabelingApp, _React$Component);

  function WhiteLabelingApp(props) {
    _classCallCheck(this, WhiteLabelingApp);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(WhiteLabelingApp).call(this, props));

    _this.state = {
      selectedColor: '#000000',
      blinkingComponent: 'DocumentHeader'
    };
    return _this;
  }

  _createClass(WhiteLabelingApp, [{
    key: 'handleChange',
    value: function handleChange(color) {
      this.setColor('#' + color.hex);
    }
  }, {
    key: 'setColor',
    value: function setColor(color) {
      this.setState({ selectedColor: color });
    }
  }, {
    key: 'changeBlinkingComponent',
    value: function changeBlinkingComponent(component) {
      if (component === 'DocumentHeader') {
        this.setState({ blinkingComponent: 'ColorPickerUI' });
      } else {
        this.setState({ blinkingComponent: null });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var props = _extends({
        handleChange: this.handleChange.bind(this),
        setColor: this.setColor.bind(this),
        changeBlinkingComponent: this.changeBlinkingComponent.bind(this)
      }, this.state);
      return _jsx('div', {
        className: 'm-white-labeling-app'
      }, void 0, _jsx('img', {
        src: require('./assets/white_labeling_social_media.gif'),
        'aria-hidden': true,
        className: 'white-labeling-gif'
      }), _react2['default'].createElement(_documentUi2['default'], props), _react2['default'].createElement(_colorPickerUi2['default'], props));
    }
  }]);

  return WhiteLabelingApp;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/white-labeling/index.jsx
 ** module id = 868
 ** module chunks = 0
 **/